// extracted by mini-css-extract-plugin
export default {"normalModeContainer":"CustomRadio_normalModeContainer__dUueo","checkmark":"CustomRadio_checkmark__5ECip","service":"CustomRadio_service__4Z3tB"};